import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param newCumulativeOperatingHours number
 * @param organisationId String
 * @param blockUI boolean
 * @return {Promise<any>|Promise}
 */
export default (function (newCumulativeOperatingHours, organisationKey, deviceId, blockUI) {
    if (blockUI === void 0) { blockUI = true; }
    var url = applyPathVariables(EndPoints.UPDATE_DEVICE_OPERATING_HOURS, {
        organisationId: organisationKey,
        device: deviceId,
    });
    var request = new Request({
        method: Methods.POST,
        url: url,
        data: { value: newCumulativeOperatingHours },
        withCredentials: true,
        blockUI: blockUI
    });
    return request.execute();
});
